import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import styled, { css } from 'styled-components';
import colors from '@theme/colors';
import { FlexContainer } from '@layout';

const Label = styled.label`
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${colors.BORDER_GREY};
    `}
`;

const CheckboxBlock = ({ id, label, checked, onCheck, disabled }) => (
  <FlexContainer>
    <div>
      <Checkbox id={id} onCheck={onCheck} checked={checked} disabled={disabled} />
    </div>
    <Label htmlFor={id} disabled={disabled}>
      {label}
    </Label>
  </FlexContainer>
);

CheckboxBlock.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
};

CheckboxBlock.defaultProps = {
  label: '',
};

export default CheckboxBlock;



// WEBPACK FOOTER //
// ./components/atoms/CheckboxBlock.js